/* __next_internal_client_entry_do_not_use__ useHeaderPriorityStore,HeaderPriorityProvider auto */ import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
/**
 * Context store to keep track of reactive interactions on the top header navigation
 */ var _createContextStore = createContextStore({
    isNotificationPreviewVisible: false,
    isHeaderDropdownVisibleMap: {
        ACCOUNT: false,
        NOTIFICATIONS: false,
        CATEGORIES: false,
        LANGUAGE_SELECTOR: false
    }
}, {
    name: "HeaderPriorityStore"
}), useHeaderPriorityStore = _createContextStore.useStore, HeaderPriorityProvider = _createContextStore.Provider;
export { useHeaderPriorityStore, HeaderPriorityProvider };
